import {
    AppLocalStorage,
    decodeData,
    HorseRacingLiveSchedule,
    JsBridge,
    encodeData,
    MSLiveSchedule,
    SendPreferenceCRMData,
} from './js-bridge';

export class JsBridgeMock extends JsBridge {
    appCloseNativePIP(): void {
        console.log(`call appCloseNativePIP`);
    }
    appOpenRacingLiveStream(): void {
        console.log(`call appOpenRacingLiveStream()`);
    }
    appGetLocalStorageDataRequest(): void {
        console.log(`call appGetLocalStorageDataRequest`);
        let data = localStorage.getItem('local-setting');
        try {
            const setting = decodeData<SendPreferenceCRMData>(data) || {};
            // console.log('setting----******************', setting);
            const appData: AppLocalStorage = {
                horseRacingLiveSchedule: liveScheduleData,
                MSLiveSchedule: MSLiveScheduleData,
                preferenceData: setting,
            };
            data = encodeData(appData);
        } catch (error) {
            console.error(error);
        }
        appGetLocalStorageDataResponse && appGetLocalStorageDataResponse(data || '');
        // setTimeout(() => {
        //     appGetLocalStorageDataResponse && appGetLocalStorageDataResponse(data || '');
        // }, 2000);
    }
    appGetLocalStorageDataRequestAsync(): void {
        console.log(`call appGetLocalStorageDataRequestAsync`);
        let data = localStorage.getItem('local-setting');
        try {
            const setting = decodeData<SendPreferenceCRMData>(data) || {};
            const appData: AppLocalStorage = {
                horseRacingLiveSchedule: liveScheduleData,
                MSLiveSchedule: MSLiveScheduleData,
                preferenceData: setting,
            };
            data = encodeData(appData);
        } catch (error) {
            console.error(error);
        }
        appGetLocalStorageDataResponse && appGetLocalStorageDataResponse(data || '');
        // setTimeout(() => {
        //     appGetLocalStorageDataResponse && appGetLocalStorageDataResponse(data || '');
        // }, 2000);
    }
    appShareUrl(url: string): void {
        console.log(`call appShareUrl(${url})`);
    }
    // appDirectTo(page: `CouponList` | `P-CardPage`): void {
    //     console.log(`call appDirectTo(${page})`);
    // }
    appOpenExternalBrowser(url: string): void {
        console.log(`call appOpenExternalBrowser(${url})`);
        window.open(url);
    }
    appSetUiVisibility(ui: `btnBack`, visable: boolean): void {
        console.log(`call appSetUiVisibility(${ui},${visable})`);
    }
    appSaveDiscoverPreference(data: SendPreferenceCRMData): void {
        localStorage.setItem('local-setting', encodeData(data));
    }
    appOpenNativePlayer(url: string, title: string, isPip: boolean): void {
        console.log(`appOpenNativePlayer--${url}-${title}-${isPip}`);
    }
    appOpenMsLiveStream(): void {
        console.log(`call appOpenMsLiveStream()`);
    }
    appOnLeavePreferencePage(): void {
        console.log(`call appOnLeavePreferencePage()`);
    }
    addCalendarEvent(
        title: string,
        description: string,
        eventUUID: string,
        startTime: number,
        endTime: number
    ): void | any {
        console.log(
            `call addCalendarEvent \n(${title},\n ${description},\n ${eventUUID},\n ${startTime},\n ${endTime})`
        );
    }
    setAllBettingStrategies(value: boolean): void {
        console.log('Set AllBettingStrategies: ' + value);
    }
}
/** 
 * live按钮判断当天，在判断是否有直播，在判断endtime
 * if (currentTime >= serverTime + startingMinutes && currentTime <= serverTime + startingMinutes + programDuration) {
    // 当前时间在节目开始和结束时间之间，显示直播按钮
    showLiveButton();
} else {
    // 当前时间不在范围内，隐藏直播按钮
    hideLiveButton();
}
 * */

/** 赛马直播数据 */
const liveScheduleData: HorseRacingLiveSchedule = {
    schedules: [
        {
            type: 'video',
            startingMinutes: '0',
            // programDuration: 174,
            programDuration: 1,
            active: true,
        },
    ],
    /**
     * 0- 不显示直播内容
     * 1- 显示直播内容
     */
    ELVA: {
        value: '1',
    },
    racingScheduleList: [
        {
            date: '05/11/2024',
            time: '08:40',
            endDate: '05/11/2024',
            endTime: '20:00',
            languageCode: 'en',
            isNotice: false,
            isNoticeColor: '',
            blockCountryCode: '',
            isConghua: false,
            title: 'Racing 1',
        },
        {
            date: '14/08/2024',
            time: '08:40',
            endDate: '14/08/2024',
            endTime: '23:00',
            languageCode: 'hk',
            isNotice: false,
            isNoticeColor: '',
            blockCountryCode: '',
            isConghua: false,
            title: 'SIT CN',
        },
        {
            date: '02/07/2025',
            time: '09:00',
            endDate: '02/07/2025',
            endTime: '18:40',
            languageCode: 'hk',
            isNotice: false,
            isNoticeColor: '',
            blockCountryCode: '',
            isConghua: false,
            title: 'HV EN',
        },
        {
            date: '02/07/2025',
            time: '09:00',
            endDate: '02/07/2025',
            endTime: '18:40',
            languageCode: 'en',
            isNotice: false,
            isNoticeColor: '',
            blockCountryCode: '',
            isConghua: false,
            title: 'HV EN',
        },
    ],
    system: {
        serverTime: '2025-07-02 09:12:48',
        code: 100,
        message: 'Return getPRogramScheduleList succesfully.',
    },
};

/** 六合彩直播数据 */
const MSLiveScheduleData: MSLiveSchedule = {
    schedules: [
        {
            type: 'video',
            startingMinutes: '0',
            programDuration: 1,
            // programDuration: 174,
            active: true,
        },
    ],
    /**
     * 0- 不显示直播内容
     * 1- 显示直播内容
     */
    ELVA: {
        value: '1',
    },
    msScheduleList: [
        {
            date: '25/10/2024',
            time: '09:23',
            endDate: '25/10/2024',
            endTime: '18:10',
            languageCode: 'en',
            isNotice: false,
            isNoticeColor: '',
            blockCountryCode: '',
            isConghua: false,
            title: 'MK6EN0906',
        },
        {
            date: '06/09/2024',
            time: '00:00',
            endDate: '06/09/2024',
            endTime: '22:00',
            languageCode: 'hk',
            isNotice: false,
            isNoticeColor: '',
            blockCountryCode: '',
            isConghua: false,
            title: 'MK6CH0906',
        },
        {
            date: '03/07/2025',
            time: '09:55',
            endDate: '03/07/2025',
            endTime: '19:30',
            languageCode: 'hk',
            isNotice: false,
            isNoticeColor: '',
            blockCountryCode: '',
            isConghua: false,
            title: 'MKch0222',
        },
        {
            date: '03/07/2025',
            time: '09:55',
            endDate: '03/07/2025',
            endTime: '19:30',
            languageCode: 'en',
            isNotice: false,
            isNoticeColor: '',
            blockCountryCode: '',
            isConghua: false,
            title: 'MKen0222',
        },
    ],
    system: {
        serverTime: '2025-07-02 09:16:32',
        code: 100,
        message: 'Return getPRogramScheduleList succesfully.',
    },
};

/** app数据mock */
export const mockStorageData = {
    horseRacingLiveSchedule: {
        schedules: [
            {
                type: 'video',
                startingMinutes: '0',
                programDuration: 22145,
                active: true,
            },
        ],
        ELVA: {
            value: '1',
        },
        racingScheduleList: [
            {
                date: '05/11/2024',
                time: '08:40',
                endDate: '05/11/2024',
                endTime: '20:00',
                languageCode: 'en',
                isNotice: false,
                isNoticeColor: '',
                blockCountryCode: '',
                isConghua: false,
                title: 'Racing 1',
            },
            {
                date: '14/08/2024',
                time: '08:40',
                endDate: '14/08/2024',
                endTime: '23:00',
                languageCode: 'hk',
                isNotice: false,
                isNoticeColor: '',
                blockCountryCode: '',
                isConghua: false,
                title: 'SIT CN',
            },
        ],
        system: {
            serverTime: '2024-11-12 09:06:05',
            code: 100,
            message: 'Return getPRogramScheduleList succesfully.',
        },
    },
    MSLiveSchedule: {
        schedules: [
            {
                type: 'video',
                startingMinutes: '0',
                programDuration: 174,
                active: true,
            },
        ],
        ELVA: {
            value: '1',
        },
        msScheduleList: [
            {
                date: '25/10/2024',
                time: '09:23',
                endDate: '25/10/2024',
                endTime: '18:10',
                languageCode: 'en',
                isNotice: false,
                isNoticeColor: '',
                blockCountryCode: '',
                isConghua: false,
                title: 'MK6EN0906',
            },
            {
                date: '06/09/2024',
                time: '00:00',
                endDate: '06/09/2024',
                endTime: '22:00',
                languageCode: 'hk',
                isNotice: false,
                isNoticeColor: '',
                blockCountryCode: '',
                isConghua: false,
                title: 'MK6CH0906',
            },
        ],
        system: {
            serverTime: '2024-11-15 09:20:29',
            code: 100,
            message: 'Return getPRogramScheduleList succesfully.',
        },
    },
    // preferenceData: {},
    /** 3月版本 */
    // preferenceData: {
    //     preferences: {
    //         step1: 'novice',
    //         step2: [
    //             'simulcast-race',
    //             'inside-the-stable',
    //             'trivia-fun-facts',
    //             'trainer-and-jockey',
    //             'dining-happenings',
    //         ],
    //         step3: [
    //             'AAtzeni',
    //             'MChadwick',
    //             'PFYiu',
    //             'JRichards',
    //             'KingMiles_J158',
    //             'LuckySweynesse_G180',
    //         ],
    //         noFirstTimePreference: true,
    //     },
    //     nweUser: false,
    //     steps: 1,
    //     latestTrackTime: 21211212121,
    // },
    /**4月版本 */
    preferenceData: {
        step1: [],
        step2: [],
        Horses: [],
        Trainers: [],
        Jockeys: [],
        Music: ['Pop', 'Jazz'],
        'Personal Interests': ['Pets'],
        'Dinning Preference': ['JSize'],
        notFirstTimePreference: ['false'],
        newUser: ['false'],
        steps: ['1'],
        latestTrackTime: ['undefined'],
    },
};
